import { useState, useEffect } from 'react'

export function useDataFetch(fetcher, params = [], deps = []) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchData = async () => {
    setLoading(true)
    setError(null)
    try {
      const result = await fetcher(...params)
      setData(result)
    
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    setData(null)
    fetchData()
    
    // eslint-disable-next-line
  }, deps || [])

  return { data, loading, error, refetch: fetchData }
}
